import './App.css';
import { Outlet } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <>
      <ScrollToTop />

      <main className="w-full min-h-screen overflow-x-hidden pt-[100px]">
        <Outlet />
      </main>
    </>
  );
}

export default App;